/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Описывает успешность статуса currentStatus
 * @export
 * @enum {string}
 */
export enum ApplicationDocumentState {
  SuccessState = 'SUCCESS_STATE',
  HasProblemState = 'HAS_PROBLEM_STATE',
  InProcessState = 'IN_PROCESS_STATE',
  FailedState = 'FAILED_STATE',
}

export function instanceOfApplicationDocumentState(value: any): boolean {
  for (const key in ApplicationDocumentState) {
    if (Object.prototype.hasOwnProperty.call(ApplicationDocumentState, key)) {
      if (
        ApplicationDocumentState[
          key as keyof typeof ApplicationDocumentState
        ] === value
      ) {
        return true
      }
    }
  }
  return false
}

export function ApplicationDocumentStateFromJSON(
  json: any
): ApplicationDocumentState {
  return ApplicationDocumentStateFromJSONTyped(json, false)
}

export function ApplicationDocumentStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApplicationDocumentState {
  return json as ApplicationDocumentState
}

export function ApplicationDocumentStateToJSON(
  value?: ApplicationDocumentState | null
): any {
  return value as any
}
